import { Feature } from "../classes/feature";
import { Product } from "../classes/product";
import { ProductGroup } from "../classes/productGroup";

export function getFormattedDate(date: Date) {
  return date ? new Date(date).toLocaleDateString("de-DE") : undefined;
}

export function getFormattedParamDate(date: Date): string {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export function featureIsDiff(
  feature: Feature,
  productGroup: ProductGroup
): boolean {
  const featureValues: Array<string | boolean | undefined> = [];
  productGroup.products.forEach((product: Product) => {
    featureValues.push(product.getFeatureValue(feature.id)?.value);
  });
  return (
    !featureValues.every((val, i, arr) => val === arr[0]) || feature.primary
  );
}
